import { FileTextIcon, ZapIcon, BotIcon, SmartphoneIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF & Mobile Access'
}, {
  icon: ZapIcon,
  label: 'Instant Download'
}, {
  icon: BotIcon,
  label: 'Works with ChatGPT, Claude, Gemini & DeepSeek'
}, {
  icon: SmartphoneIcon,
  label: 'Designed for desktop, tablet & mobile'
}];
export const stats = [{
  value: '400+',
  label: 'Satisfied Firefighters'
}, {
  value: "6\xA0 +\xA0 4",
  label: 'Volumes + Bonus'
}, {
  value: '99%',
  label: 'Success Rate'
}, {
  value: '4.9/5',
  label: '⭐ Global Rating'
}];